import RequirementsAPI from './requirements';

// Tramite-scoped requirements (requisitos) checklist singleton.
// Owner id is the tramite id (the URL identifier for nested tramite routes).
export default new RequirementsAPI('tramites');
